import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import React, { memo } from 'react'

export interface Props {
  icon?: string
  label?: string
}

export const Item = memo(function Item({ icon, label }: Props) {
  return (
    <Container row>
      {icon ? (
        <IconWrap dial={5}>
          <SVG src={icon} width="30" height="24" alt={label} />
        </IconWrap>
      ) : null}
      {label ? <Label>{label}</Label> : null}
    </Container>
  )
})

const Container = styled(FlexBox)`
  margin-top: 3rem;
  &:first-of-type {
    margin-top: 0;
  }

  @media (max-width: 1023px) {
    margin-top: 2.25rem;
  }
`

const IconWrap = styled(FlexBox)`
  width: 30px;
  height: 30px;
  margin-right: 1rem;
`

const SVG = styled.img`
  width: 100%;
  height: auto;
  max-height: 1.875rem;
`

const Label = styled.span`
  display: block;
  color: ${({ theme }) => theme.colors.variants.neutralDark4};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.9375rem;
  line-height: 1.75rem;
`
